module.exports = __webpack_public_path__ + "img/shield-protect.webp";